import React, { useEffect, useState } from "react";
import { Text, View, TouchableOpacity } from "react-native";

import styles from "./timeStyles";

export default function TimeSlotItemStartTime({
  timeslot,
  prevTimeslot,
  index,
  onPress,
}) {
  const [startTime, setStartTime] = useState(null);
  const [meridian, setMeridian] = useState(null);

  useEffect(() => {
    if (!timeslot.startTime) return;

    const times = timeslot.startTime.split(" ");
    if (times[0]) setStartTime(times[0]);

    // Show meridian for 1st timeslot in the list and 1st after noon
    const showPM =
      (prevTimeslot != null &&
        prevTimeslot.startTime.endsWith("AM") &&
        prevTimeslot.endTime.endsWith("PM")) ||
      timeslot.startTime === "12:00 PM";
    if (times[1] && (index == 0 || showPM)) {
      setMeridian(times[1]);
    }
  }, [timeslot.startTime]);

  return (
    <>
      {onPress ? (
        <TouchableOpacity onPress={onPress} style={styles.timeContainer}>
          {startTime ? (
            <Text style={[styles.time, styles.enabledTime]}>{startTime}</Text>
          ) : null}
          {meridian ? (
            <Text style={[styles.meridian, styles.enabledTime]}>{meridian}</Text>
          ) : null}
        </TouchableOpacity>
      ) : (
        <View style={styles.timeContainer}>
          {startTime ? <Text style={styles.time}>{startTime}</Text> : null}
          {meridian ? <Text style={styles.meridian}>{meridian}</Text> : null}
        </View>
      )}
    </>
  );
}
